var React = require('react');

function Delete (props) {
    return React.createElement("svg",props,React.createElement("g",{"fill":"currentColor","fillRule":"evenodd"},[React.createElement("path",{"d":"M14.52 14.735c-.683.683-1.838.636-2.58-.105L1.2 3.89C.46 3.15.413 1.994 1.097 1.31c.683-.683 1.838-.636 2.58.105l10.74 10.74c.74.741.788 1.896.104 2.58z","key":0}),React.createElement("path",{"d":"M.916 14.765c-.684-.683-.637-1.838.105-2.58l10.74-10.74c.741-.74 1.896-.788 2.58-.105.683.684.636 1.839-.106 2.58L3.495 14.66c-.74.741-1.896.789-2.58.105z","key":1})]));
}

Delete.defaultProps = {"width":"15","height":"16","viewBox":"0 0 15 16"};

module.exports = Delete;

Delete.default = Delete;
